import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlanneLogoColor = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 1358 372",
	style: { enableBackground: "new 0 0 1358 372" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.st0{fill:#131552;}\n	.st1{fill:#FFFFFF;}\n	.st2{fill:#57E3A4;}\n	.st3{fill:#006CFF;}\n	.st4{fill:#9C50F3;}\n"
	}), /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M479.61,145.15c-5.04-5.08-11.14-7.62-18.28-7.62h-121.9v14.81h117.93c3.06,0,5.68,1.07,7.87,3.22 c2.15,2.19,3.22,4.79,3.22,7.81c0,3.06-1.07,5.68-3.22,7.87c-2.19,2.15-4.81,3.22-7.87,3.22H339.42v59.56h16.01v-44.75h105.89 c7.15,0,13.24-2.54,18.28-7.62c5.08-5.04,7.62-11.13,7.62-18.28C487.23,156.26,484.69,150.19,479.61,145.15z"
		}) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("polygon", {
			className: "st0",
			points: "508.1,137.73 524.67,137.73 524.67,217.8 623.4,217.8 623.4,233.65 508.1,233.65  "
		}) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("polygon", {
			className: "st0",
			points: "645.18,233.73 717.32,137.81 729.57,137.81 805.32,233.73 785.14,233.73 724.53,157.26  666.8,233.73  "
		}) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("polygon", {
			className: "st0",
			points: "826.21,234.47 826.21,137.73 844.54,137.73 939.82,215.42 939.82,137.73 956.68,137.73  956.68,233.74 937.62,233.74 842.34,156.05 842.34,234.47  "
		}) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("polygon", {
			className: "st0",
			points: "978.67,234.47 978.67,137.73 996.99,137.73 1092.27,215.42 1092.27,137.73 1109.13,137.73  1109.13,233.74 1090.07,233.74 994.79,156.05 994.79,234.47  "
		}) }),
		/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("rect", {
			x: 1130.33,
			y: 137.81,
			className: "st0",
			width: 120.34,
			height: 16.57
		}) }), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("polygon", {
			className: "st0",
			points: "1130.33,181.76 1250.67,181.76 1250.67,197.62 1146.18,197.62 1146.18,217.8 1250.67,217.8  1250.67,233.65 1130.33,233.65  "
		}) })] })
	] }), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
		className: "st2",
		d: "M131.41,315.45l-0.02-37.69l-23.94,14.89l-0.12-236.09l172.21,99.28l-27.78,16.06l28.72,16.56l-74.49,43.07 l-15.78,9.65l-25.63,15.94l0,37.39L131.41,315.45z M140.99,271.79l0.01,26.27l14.02-8.85l0-26.14L140.99,271.79z M116.93,73.16 l0.05,82.78l0.05,119.45l14.36-8.93l-0.03-77.92l-0.05-86.1l110.87,63.92l18.19-10.52L116.93,73.16z M140.91,119.05l0.04,69.49 l0.03,71.96l14.03-8.72L155,171.66l-0.02-27.81l48.18,27.78l-24,13.88l-14.57,9.09l0,17.4l24.1-14.72l43.89-25.37L140.91,119.05z  M164.6,223.23l0,22.58l20.6-12.81l15.96-9.76l60.16-34.78l-19.13-11.03l-48.63,28.12L164.6,223.23z M164.59,160.46l0.01,22.84 l9.7-6.05l9.69-5.6L164.59,160.46z"
	}) })] })]
});
export default SvgPlanneLogoColor;
